// extracted by mini-css-extract-plugin
export default {"container":"footer_container__2WLad","menu":"footer_menu__20pzY","menuItems":"footer_menuItems__36qvM","bottom":"footer_bottom__RnkAx"};